<template>
  <div class="store-info">
    <div class="store-wapper flex" v-if="false">
      <div class="store-logo">
        <img :src="storeInfo.logo" />
      </div>
      <div class="store-tables">
        <div class="tables-info flex">
          <div class="label">{{ $t("translate.table_room") }}</div>
          <div class="colons">:</div>
          <div class="text">{{storeInfo.tablesRoom}}</div>
        </div>
        <div class="order-info flex">
          <div class="label">{{ $t("translate.order_no") }}</div>
          <div class="colons">:</div>
          <div class="text">{{storeInfo.orderNo}}</div>
        </div>
      </div>
    </div>
    <!-- bar-animated -->
      <div class="box" :style="(stepsList.length==4 && active== 2 && orderInfo.eta_time > 0) ? 'min-height:130px;margin:0;padding-bottom:20px':''">
        <div class="progress">
          <div class="point" :class="{'mode1':stepsList.length==3,'mode2':stepsList.length==4,'etaOngoing':(stepsList.length==4 && index==2)}" v-for="(item, index) in stepsList" :key="index">
              <label class="label" :class="{'label-active': active==index}">{{item.toUpperCase()}}</label>
              <div class="bullet-container">
                <div class="bullet" :class="{'bullet-active': active>index}"></div>
                <div v-if="active == index" class="bullet-sign">
                  <v-icon color="#0bc15f" size="14">
                    {{icons.mdiCheckCircle}}
                  </v-icon>
                  </div>

                <div v-if="active == 2 && orderInfo.eta_time > 0" class="etaOrder">
                  <div style="color:#2c3d4f">ETA:</div>
                  <div style="color: rgb(238, 45, 36);">{{dateEta}}</div>
                  <div style="color: rgb(238, 45, 36);">{{fromEta}} - {{toEta}}</div>
                </div>

              </div>
              <div class="line line-loader">
                <div :class="{'loader-ongoing': active==index, 'loader-completed': active>index}"></div>
              </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import moment from 'moment';
import { mdiCheckCircle } from '@mdi/js';
export default {
  props:{
    storeInfo:{
      type:Object,
      default:()=>{
        return {
          logo:'https://media.cdnandroid.com/5b/c8/bc/be/33/imagen-chinese-california-truck-fast-food-cooking-game-0thumb.jpg',
          tablesRoom:'ROOM 5',
          orderNo:'123456789',
          orderStatus:1
        }
      }
    },
    orderInfo:{
      type:Object,
      default:()=>{
        return {}
      }
    },
    orderStatus:{
      type:Number,
      default:0
    },
    isAccept:{
      type:Number,
      default:0
    },
    stepsList:{
      type:Array,
      default:() => {
        return ['Add Order', 'Dining', 'Completed']
      }
    }
  },
  data () {
    return {
      icons: {
        mdiCheckCircle
      },
      active: 1,
      fromEta: 0,
      toEta: 0,
      dateEta: 0
    }
  },
  created () {
    if (this.orderInfo != null){
        if (this.orderInfo.eta_time > 0){
            this.dateEta = moment(this.orderInfo.eta_time * 1000).utcOffset('+0800').format('dddd, D MMM YYYY');
            this.fromEta = moment(this.orderInfo.eta_time * 1000).utcOffset('+0800').format('HH:mmA');
            let to = moment(this.orderInfo.eta_time * 1000).add(15, 'm')
            this.toEta = to.utcOffset('+0800').format('HH:mmA');
        }
        if (this.orderInfo.dining_mode == 2){
            if (this.isAccept != null){
                if (this.orderStatus == 1 && this.isAccept == 0){
                    this.active = 2;
                } else if (this.orderStatus == 3){
                    this.active = 3;
                } else {
                    this.active = this.orderStatus + this.isAccept;
                }
            } else {
                this.active = this.orderStatus;
            }
            console.log('this.active',this.active)
        } else {
            this.active = this.orderStatus;
        }
    } else {
        this.active = this.orderStatus;
    }
    // this.active=3 //edit
    console.log('this active',this.active)
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');

.box {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 0 5px;
  box-sizing: border-box;
  transform-origin: center;
  margin: .8rem 0 0 ;
  padding: 0 10px;
  min-height: 60px;
}

.progress {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.point{
  .bullet-container{
    .etaOrder {
      display: none;
    }    
  }
}
.point:last-child{
  width: 0;
  label{
    transform: translateX(-100%);
  }
  .bullet-container{
    margin-left:-14px ;
  }
}

.mode1:nth-child(2){
  label{
    transform: translateX(-50%);
  }
}
.mode2:nth-child(2){
  label{
    transform: translateX(-50%);
  }
}
.mode2:nth-child(3){
  label{
    transform: translateX(-50%);
  }
}
.etaOngoing{
  .bullet-container{
    .etaOrder {
      display: block;
      font-size: 12px;
      text-align: center;
      font-weight: bolder;
      padding: 10px;
      position: absolute;
      bottom: -70px;
      width: 200px;
    }    
  }
}



.point{
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.bullet-container {
  position: absolute;
  z-index:1;
  background: #fff;
  display: grid;
  place-items: center;
  width: 20px;
  height: 12px;
  top: -5px;
  margin-left: -8px;
  
}
.bullet {
  z-index:1;
  background: #969799;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  top: 10px;
}
.bullet-active {
  background: @green5;
}
.bullet-sign{
  position: absolute;
  background: rgb(255, 255, 255);
  width: 22px;
  display: grid;
  place-items: center;
  z-index: 2;
  top: -2px;
  left: 0px;
}
.line{
  background: #e1e3e6;
  height: 2px;
  width: 100% !important;
}
.line-loader .loader-completed{
  height: 2px;
  background-color: @green5;
}
.loader-ongoing{
  height: 2px;
  transition: 0.4s cubic-bezier(1,.22,.86,.65);
  transition-property:width, background-col ;
}
.line-loader .loader-ongoing{
  background-color: @green5;
  animation: loader 3s infinite;
}

@keyframes loader {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

.label {
  position: absolute;
  font-size: 12px;
  top: -30px;
  left: 0;
  color: rgb(85, 85, 85);
  @media screen and (max-width:360px){ 
    font-size: 11px;
  }
}
.label-active{
  color: @green5;
}

.store-info {
  background-color: @fff;
  .store-wapper {
    padding: 8px;
    .store-logo {
      width: 100px;
      margin: 0 8px 0 0;
      img {
        width: 100%;
        max-width: 100px;
        max-height: 80px;
      }
    }
    .store-tables {
      font-size: @size14;
      .label {
        cursor: pointer;
      }
      .colons {
        padding: 0 5px;
      }
      .text {
        color: rgba(0, 0, 0, 0.7);
      }
      .tables-info {
        margin: 5px 0;
      }
      .order-info {
        margin: 5px 0;
      }
    }
  }

  .etaOrder {
    font-size: 12px;
    text-align: center;
    font-weight: bolder;
    padding: 10px;
  }
}
</style>